/* eslint-disable complexity */
/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable extra-rules/no-commented-out-code */
import React from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import Button from '@tcp/core/src/components/common/atoms/Button';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Row from '@tcp/core/src/components/common/atoms/Row';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getPageGenerationDate, getViewportInfo } from '@tcp/core/src/utils/utils.web';
import {
  getAPIConfig,
  isClient,
  isCanada,
  callNavigateAPIForExternalLinks,
} from '@tcp/core/src/utils/utils';
import { getDeviceTier } from '@tcp/web/src/utils/device-tiering';
import { generateSessionId, feRegionCookieVal } from '@tcp/core/src/utils/cookie.util';
import CountrySelector from '../../HeaderNew/molecules/CountrySelector';
import {
  FooterMiddleMobile,
  FooterMiddleDesktop,
  LegalLinks,
  Copyright,
  FooterTopCandidateA,
  FooterTopCandidateB,
} from '../molecules';
import style, { StyledFooterWrapper } from '../Footer.style';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFooterTopCandidateB: false,
      sample: generateSessionId(false),
      hasMounted: false,
    };
  }

  componentDidMount() {
    // TODO: Need to change this when proper solution for A/B test come
    this.setState({
      hasMounted: true,
    });
    if (window.location.search.match('cand-b')) {
      this.setState({ showFooterTopCandidateB: true });
    } else {
      this.setState({ showFooterTopCandidateB: false });
    }
    // eslint-disable-next-line no-unused-vars
    this.listenCookieChange(({ oldValue, newValue }) => {
      this.setState({ sample: generateSessionId(false) });
      if (newValue.includes('QuantumMetricSessionID')) {
        clearInterval(this.cookieclear);
      }
    }, 500);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (isEqual(nextProps, this.props) && isEqual(nextState, this.state)) {
      return false;
    }
    return true;
  }

  shouldPlccTakeOver = () => {
    const { plccOfferTakeOverABTestEnabled } = this.props;
    return plccOfferTakeOverABTestEnabled && !isCanada();
  };

  listenCookieChange(callback, interval = 1000) {
    let lastCookie = document.cookie;
    this.cookieclear = setInterval(() => {
      // eslint-disable-next-line prefer-destructuring
      const cookie = document.cookie;
      if (cookie !== lastCookie) {
        try {
          callback({ oldValue: lastCookie, newValue: cookie });
        } finally {
          lastCookie = cookie;
        }
      }
    }, interval);
  }

  mergeNavAndLegalLinks = () => {
    const { navLinks, legalLinks } = this.props;

    // Helper function to capitalize the first letter of each word
    const toTitleCase = (str) => {
      return str.replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    };
    // Create a new array by mapping over navLinks to transform header text to lowercase
    // This step ensures that we are not modifying the original navLinks array
    const transformedNavLinks = navLinks.map((link) => ({
      ...link, // Spread the properties of the original link object
      header: {
        ...link.header, // Spread the original header object
        text: toTitleCase(link.header.text), // Convert header text to title case
      },
    }));

    // Define a new link object for legal links with the header text 'Policies'
    const newLink = {
      header: { text: 'Policies' },
      links: [...legalLinks], // Use spread to copy legalLinks
    };

    // Combine the transformed navLinks with the new legal links link into a new array
    // This final step also ensures that we are not modifying any original data
    return [...transformedNavLinks, newLink];
  };

  // eslint-disable-next-line react/sort-comp
  componentWillUnmount() {
    clearInterval(this.cookieclear);
  }

  render() {
    const { props } = this;
    const {
      className,
      copyrightText,
      legalLinks,
      navLinks,
      getUserInfoAction,
      getOrderDetailAction,
      isLoggedIn,
      linkConfig,
      footerActionCreator,
      isNavigationFooter,
      defaultStore = {},
      isPlcc,
      isGuest,
      fullPageAuthEnabled,
      isRecommendationSidebar,
      isPreCheckoutFlow,
      trackAnalyticsClick,
      isFooterRedesignEnabled,
      links,
      updateExpandedState,
      offerZoneState,
      isPdpPage,
    } = props;
    const { showFooterTopCandidateB, hasMounted } = this.state;
    const buildVersion = getAPIConfig().BUILD_NUMBER;
    const getReferenceId = generateSessionId(false);
    const feRegion = feRegionCookieVal();
    let { isDesktop = false } = getViewportInfo() || {};
    if (isPdpPage && !hasMounted) {
      isDesktop = true;
    }
    const renderFooterTop = () => (
      <Row
        className={`footer-candidate-wrapper ${isFooterRedesignEnabled ? 'footer-top-cls' : ''}`}
        fullBleed={!isNavigationFooter}
        onClick={callNavigateAPIForExternalLinks}
      >
        {isNavigationFooter && (
          <Col
            colSize={{
              large: 12,
              medium: 8,
              small: 6,
            }}
          >
            <div className="divider hide-in-large-up" />
          </Col>
        )}
        {showFooterTopCandidateB ? (
          <FooterTopCandidateB
            isNavigationFooter={isNavigationFooter}
            isDesktop={isDesktop}
            {...props}
          />
        ) : (
          <FooterTopCandidateA
            isNavigationFooter={isNavigationFooter}
            isDesktop={isDesktop}
            updateExpandedState={updateExpandedState}
            {...props}
          />
        )}
      </Row>
    );

    // Function to render the middle part of the footer for mobile
    const renderFooterMiddleMobile = () => (
      <Row className="footer-middle mobile" fullBleed onClick={callNavigateAPIForExternalLinks}>
        <FooterMiddleMobile
          className={className}
          navLinkItems={isFooterRedesignEnabled ? this.mergeNavAndLegalLinks() : navLinks}
          isLoggedIn={isLoggedIn}
          linkConfig={linkConfig}
          footerActionCreator={footerActionCreator}
          defaultStore={defaultStore}
          isPlcc={isPlcc}
          isGuest={isGuest}
          fullPageAuthEnabled={fullPageAuthEnabled}
          isFooterRedesignEnabled={isFooterRedesignEnabled}
          links={links}
          trackAnalyticsClick={trackAnalyticsClick}
          isNavigationFooter={isNavigationFooter}
          offerZoneState={offerZoneState}
          updateExpandedState={updateExpandedState}
        />
      </Row>
    );

    // Function to render the middle part of the footer for desktop
    const renderFooterMiddleDesktop = () => (
      <Row
        className={`content-wrapper ${isFooterRedesignEnabled ? 'footer-middle-cls' : ''}`}
        fullBleed
        onClick={callNavigateAPIForExternalLinks}
      >
        <Row className="footer-middle desktop">
          <FooterMiddleDesktop
            className={className}
            navLinks={navLinks}
            isLoggedIn={isLoggedIn}
            linkConfig={linkConfig}
            footerActionCreator={footerActionCreator}
            defaultStore={defaultStore}
            isPlcc={isPlcc}
            isGuest={isGuest}
            fullPageAuthEnabled={fullPageAuthEnabled}
            isFooterRedesignEnabled={isFooterRedesignEnabled}
            links={links}
            trackAnalyticsClick={trackAnalyticsClick}
          />
        </Row>
      </Row>
    );

    const deskPreCheckOutCheck = isDesktop && !isPreCheckoutFlow;
    const mobileFlow = !isDesktop && !isPreCheckoutFlow;
    const renderFooter = () => {
      return !isFooterRedesignEnabled ? (
        <>
          {!isPreCheckoutFlow && renderFooterTop()}
          {!isDesktop && !isPreCheckoutFlow && renderFooterMiddleMobile()}
          {isDesktop && !isPreCheckoutFlow && renderFooterMiddleDesktop()}
          <div className={`${isPreCheckoutFlow ? 'pre-checkout-footer-bottom' : ''} footer-bottom`}>
            <Row className="content-wrapper" onClick={callNavigateAPIForExternalLinks}>
              <Row className="fullbleed-mobile">
                <Col
                  className="footer-bottom__slot--1 default-offset"
                  colSize={{
                    large: 2,
                    medium: 8,
                    small: 6,
                  }}
                >
                  <Copyright>{copyrightText}</Copyright>
                  <div className="poc-hide">
                    <Button onClick={getUserInfoAction}>Get Registered User Info</Button>
                    <Button onClick={getOrderDetailAction}>Get Order detail</Button>
                  </div>
                </Col>
                <Col
                  className="footer-bottom__slot--2 default-offset"
                  colSize={{
                    large: 8,
                    medium: 8,
                    small: 6,
                  }}
                >
                  <LegalLinks links={legalLinks} className="footer-legel-links" />
                </Col>
                {!isPreCheckoutFlow && (
                  <Col
                    className="footer-bottom__slot--3 default-offset"
                    colSize={{
                      large: 2,
                      medium: 8,
                      small: 6,
                    }}
                  >
                    <CountrySelector showInFooter trackAnalyticsClick={trackAnalyticsClick} />
                  </Col>
                )}
              </Row>
              <Row fullBleed>
                <Col
                  colSize={{
                    large: 12,
                    medium: 8,
                    small: 6,
                  }}
                >
                  <BodyCopy className="reference-id" fontSize="fs32">
                    {isClient() ? `${getReferenceId} | ${getPageGenerationDate()}` : ''}
                    {buildVersion ? ` | ${buildVersion}` : ''}
                    {` | ${getDeviceTier()} | ${feRegion}`}
                  </BodyCopy>
                </Col>
              </Row>
            </Row>
          </div>
        </>
      ) : (
        <>
          {isDesktop && (
            <div className="footer-wrapper">
              {!isPreCheckoutFlow && renderFooterTop()}
              {deskPreCheckOutCheck && renderFooterMiddleDesktop()}
            </div>
          )}
          {mobileFlow && (
            <>
              {isNavigationFooter && renderFooterTop()}
              {renderFooterMiddleMobile()}
            </>
          )}

          <div
            className={`${
              isPreCheckoutFlow ? 'pre-checkout-footer-bottom' : ''
            } footer-bottom footer-bottom-redesign`}
          >
            <Row
              className="content-wrapper content-wrapper-new"
              onClick={callNavigateAPIForExternalLinks}
            >
              <Row className="fullbleed-mobile">
                <Col
                  className="footer-bottom__slot--1 default-offset"
                  colSize={{
                    large: 2,
                    medium: 8,
                    small: 6,
                  }}
                >
                  <Copyright isFooterRedesignEnabled={isFooterRedesignEnabled}>
                    {copyrightText}
                  </Copyright>
                  <div className="poc-hide">
                    <Button onClick={getUserInfoAction}>Get Registered User Info</Button>
                    <Button onClick={getOrderDetailAction}>Get Order detail</Button>
                  </div>
                </Col>
                <Col
                  className="footer-bottom__slot--2 default-offset"
                  colSize={{
                    large: 10,
                    medium: 8,
                    small: 6,
                  }}
                >
                  <LegalLinks links={legalLinks} className="footer-legel-links" />
                </Col>
                {/* {!isPreCheckoutFlow && (
                  <Col
                    className="footer-bottom__slot--3 default-offset"
                    colSize={{
                      large: 2,
                      medium: 8,
                      small: 6,
                    }}
                  >
                    <CountrySelector showInFooter trackAnalyticsClick={trackAnalyticsClick} />
                  </Col>
                )} */}
              </Row>
              {mobileFlow && (
                <Row fullBleed>
                  <Col
                    colSize={{
                      large: 0,
                      medium: 8,
                      small: 6,
                    }}
                  >
                    <BodyCopy className="reference-id" fontSize="fs32">
                      {isClient() ? `${getReferenceId} | ${getPageGenerationDate()}` : ''}
                      {buildVersion ? ` | ${buildVersion}` : ''}
                      {` | ${getDeviceTier()} | ${feRegion}`}
                    </BodyCopy>
                  </Col>
                </Row>
              )}
            </Row>
          </div>
        </>
      );
    };
    return (
      <footer className={`${className} footer-global`}>
        {isRecommendationSidebar ? (
          <StyledFooterWrapper
            isNewPdpSideBar={isRecommendationSidebar}
            isFooterRedesignEnabled={isFooterRedesignEnabled}
          >
            {renderFooter()}
          </StyledFooterWrapper>
        ) : (
          renderFooter()
        )}
      </footer>
    );
  }
}

Footer.propTypes = {
  className: PropTypes.string.isRequired,
  copyrightText: PropTypes.string,
  navLinks: PropTypes.array,
  legalLinks: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.text,
    })
  ),
  getUserInfoAction: PropTypes.func,
  openEmailSignUpModal: PropTypes.func,
  openSmsSignUpModal: PropTypes.func,
  getOrderDetailAction: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool,
  linkConfig: PropTypes.shape({
    'track-order': PropTypes.func,
    favorites: PropTypes.func,
    'log-out': PropTypes.func,
    'login-account': PropTypes.func,
    'create-account': PropTypes.func,
  }).isRequired,
  footerActionCreator: PropTypes.func.isRequired,
  pageName: PropTypes.string,
  isNavigationFooter: PropTypes.bool,
  isLocationEnabledForGuest: PropTypes.bool,
  isLocationEnabledForLoggedInUser: PropTypes.bool,
  defaultStore: PropTypes.shape({}),
  isPlcc: PropTypes.bool,
  isGuest: PropTypes.bool,
  isEmailModalOpen: PropTypes.bool,
  isSMSModalOpen: PropTypes.bool,
  openPlccOfferModal: PropTypes.func,
  isRegisteredUserCallDone: PropTypes.bool,
  fullPageAuthEnabled: PropTypes.bool,
  isPlccOfferModalOpen: PropTypes.bool,
  isPdpPage: PropTypes.bool,
  isRecommendationSidebar: PropTypes.bool,
  isReferFriendDisabled: PropTypes.bool,
  trackAnalyticsClick: PropTypes.func,
};

Footer.defaultProps = {
  copyrightText: '',
  legalLinks: [],
  navLinks: [],
  isLoggedIn: false,
  pageName: '',
  openEmailSignUpModal: () => {},
  openSmsSignUpModal: () => {},
  isNavigationFooter: false,
  isLocationEnabledForGuest: true,
  isLocationEnabledForLoggedInUser: true,
  defaultStore: {},
  isPlcc: false,
  isGuest: false,
  isEmailModalOpen: false,
  isSMSModalOpen: false,
  openPlccOfferModal: () => {},
  isRegisteredUserCallDone: false,
  fullPageAuthEnabled: false,
  isPlccOfferModalOpen: false,
  isPdpPage: false,
  isRecommendationSidebar: false,
  isReferFriendDisabled: false,
  trackAnalyticsClick: () => {},
};

export default errorBoundary(withStyles(Footer, style));
export { Footer as FooterVanilla };
